import React, { FC, useEffect, useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import {
  AuthPage,
  ForgetPasswordPage,
  LoginPage,
  SignUpPage
} from 'pages/native/onBoarding/pages/auth'
import { Layout } from 'pages/native/onBoarding/components'
import {
  FollowingPage,
  WelcomePage
} from 'pages/native/onBoarding/pages/onboarding'
import { getChannel } from 'api/channel/getChannel'
import { Loader } from 'components/Loader/Loader'

const ROOT_PATH = '/onboarding'
export const NATIVE_PUBLIC_ROUTES = {
  ROOT: ROOT_PATH,
  AUTH: {
    ROOT: `${ROOT_PATH}/auth`,
    LOGIN: `${ROOT_PATH}/auth/login`,
    FORGOT_PASSWORD: `${ROOT_PATH}/auth/forget-password`,
    SIGN_UP: `${ROOT_PATH}/auth/sign-up`
  },
  ON_BOARDING: {
    ROOT: `${ROOT_PATH}/`,
    WELCOME: `${ROOT_PATH}/welcome`,
    FOLLOW: `${ROOT_PATH}/follow`
  }
} as const

export const nativePublicPathGenerator = (
  path: string,
  company: string = 'solidsport'
) => {
  return `/${company}${path}`
}

interface PublicRoutesProps {
  company?: string
}

export const PublicRoutes: FC<PublicRoutesProps> = ({ company }) => {
  const [companySubdomain, setCompanySubdomain] = useState<string | undefined>(
    company
  )
  const [loading, setLoading] = useState<boolean>(false)

  const fetchCompanySubdomain = async () => {
    if (!companySubdomain) {
      setLoading(true)
      try {
        const response = await getChannel(window.location.hostname)
        setCompanySubdomain(response?.subdomain)
      } catch (error) {
        console.error('Error fetching channel:', error)
      } finally {
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    fetchCompanySubdomain()
  }, [company])

  if (loading) {
    return (
      <div>
        <Loader />
      </div>
    )
  }

  return (
    <Switch>
      <Route
        path={nativePublicPathGenerator(
          NATIVE_PUBLIC_ROUTES.ROOT,
          companySubdomain
        )}
      >
        <Layout>
          {/* Auth Routes */}
          <Switch>
            <Route
              path={nativePublicPathGenerator(
                NATIVE_PUBLIC_ROUTES.AUTH.ROOT,
                companySubdomain
              )}
            >
              <Switch>
                <Route
                  exact
                  path={nativePublicPathGenerator(
                    NATIVE_PUBLIC_ROUTES.AUTH.ROOT,
                    companySubdomain
                  )}
                  component={AuthPage}
                />
                <Route
                  path={nativePublicPathGenerator(
                    NATIVE_PUBLIC_ROUTES.AUTH.LOGIN,
                    companySubdomain
                  )}
                  component={LoginPage}
                />
                <Route
                  path={nativePublicPathGenerator(
                    NATIVE_PUBLIC_ROUTES.AUTH.FORGOT_PASSWORD,
                    companySubdomain
                  )}
                  component={ForgetPasswordPage}
                />
                <Route
                  path={nativePublicPathGenerator(
                    NATIVE_PUBLIC_ROUTES.AUTH.SIGN_UP,
                    companySubdomain
                  )}
                  component={SignUpPage}
                />
              </Switch>
            </Route>
          </Switch>
          {/* Onboarding Routes */}
          <Switch>
            <Route
              path={nativePublicPathGenerator(
                NATIVE_PUBLIC_ROUTES.ON_BOARDING.ROOT,
                companySubdomain
              )}
            >
              <Switch>
                <Route
                  exact
                  path={nativePublicPathGenerator(
                    NATIVE_PUBLIC_ROUTES.ON_BOARDING.WELCOME,
                    companySubdomain
                  )}
                  component={WelcomePage}
                />
                <Route
                  exact
                  path={nativePublicPathGenerator(
                    NATIVE_PUBLIC_ROUTES.ON_BOARDING.FOLLOW,
                    companySubdomain
                  )}
                  component={FollowingPage}
                />
              </Switch>
            </Route>
          </Switch>
        </Layout>
      </Route>
    </Switch>
  )
}
